import { useTheme } from '@mui/material/styles';

const VectorIcon = () => {
  const theme = useTheme();

  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_477_6932)">
        <path
          d="M4.32642 5V11C4.32642 11.7956 4.64249 12.5587 5.2051 13.1213C5.7677 13.6839 6.53077 14 7.32642 14H14.3264"
          stroke={theme.palette.mode === 'dark' ? 'white' : '#135799'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3264 10L14.3264 14L10.3264 18M15.3264 10L19.3264 14L15.3264 18"
          stroke={theme.palette.mode === 'dark' ? 'white' : '#135799'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_477_6932">
          <rect width="24" height="24" fill="white" transform="translate(0.326416)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VectorIcon;
